export default {
  title: 'Questo ristorante non può ancora andare online',
  description:
    'Il tuo account partner non ha una commissione di elaborazione per i pagamenti online e non ha confermato un margine dello 0%. Stripe addebita le sue commissioni alla tua piattaforma, quindi bisogna decidere una delle due opzioni.',
  partner_action:
    'Imposta una commissione di elaborazione predefinita oppure conferma di non addebitarne alcuna ai tuoi ristoranti e di pagare tu le commissioni di Stripe.',
  ask_partner:
    'Il tuo partner non ha ancora impostato la commissione di elaborazione per i pagamenti online. Questo ristorante potrà andare online non appena sarà impostata.',
  buttons: {
    set_rate: 'Imposta commissione',
    close: 'Chiudi',
  },
};
